import requestAuthToken from 'src/dataLayer/remoteData/babbelAPI/requestAuthToken'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'
import useAsyncData from 'src/viewLayer/components/hooks/useAsyncData'

export default function useHandleAuthTokenRequest(properties) {
  const { locale } = useRouteParamsContext()

  const { inProgress, makeRequest } = useAsyncData(() =>
    requestAuthToken({ locale, ...properties }),
  )

  return {
    authTokenRequestInProgress: inProgress,
    makeAuthTokenRequest: makeRequest,
  }
}
